import { render, staticRenderFns } from "./MobileDesktopRecommendationBanner.vue?vue&type=template&id=63c1945e"
import script from "./MobileDesktopRecommendationBanner.vue?vue&type=script&lang=js"
export * from "./MobileDesktopRecommendationBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports